import { useState } from "react";
import { motion } from "framer-motion";
import styles from "./css/Question.module.css";
import { pageVariants, pageTransition, staggerContainer, staggerItem, btnHover, btnTap } from "../utils/animations";

const patientValid = (v) => { const t = v.trim(); return t.length >= 10 && t.split(/\s+/).length >= 2; };
const phoneValid   = (v) => v.replace(/\s/g, "").length === 10;
const applyPhoneMask = (raw) => {
	const d = raw.replace(/\D/g, "").slice(0, 10);
	if (d.length <= 3) return d;
	if (d.length <= 6) return `${d.slice(0, 3)} ${d.slice(3)}`;
	return `${d.slice(0, 3)} ${d.slice(3, 6)} ${d.slice(6)}`;
};

const QuestionContact = ({ setAvance, setHandleEvent }) => {
	const [patient, setPatient] = useState("");
	const [phone,   setPhone]   = useState("");
	const [touched, setTouched] = useState({ patient: false, phone: false });

	const patientOk = patientValid(patient);
	const phoneOk   = phoneValid(phone);
	const isValid   = patientOk && phoneOk;

	const handleForm = () => {
		if (!isValid) return;
		setHandleEvent(prev => ({ ...prev, patient: patient.trim(), phone: phone.trim() }));
		setAvance(11);
	};

	return (
		<motion.div
			className={styles.containerQuestion}
			variants={pageVariants}
			initial="initial"
			animate="animate"
			exit="exit"
			transition={pageTransition}
		>
			<div className={styles.titleQuestion}>
				Indique su nombre completo y teléfono de contacto
			</div>

			<motion.div
				className={styles.containerMessage}
				variants={staggerContainer}
				initial="initial"
				animate="animate"
			>
				<motion.div variants={staggerItem}>
					<input
						type="text"
						className={styles.inputText}
						style={{ marginBottom: 0 }}
						value={patient}
						onChange={(e) => setPatient(e.target.value.replace(/\b\w/g, l => l.toUpperCase()))}
						onBlur={() => setTouched(t => ({ ...t, patient: true }))}
						placeholder="Nombre completo del paciente"
					/>
					{touched.patient && !patientOk && (
						<motion.span
							className={styles.fieldError}
							initial={{ opacity: 0, y: -4 }}
							animate={{ opacity: 1, y: 0 }}
							transition={{ duration: 0.2 }}
						>
							Ingrese nombre y apellido (mínimo 10 caracteres)
						</motion.span>
					)}
					{!(touched.patient && !patientOk) && <div style={{ height: "1.25rem" }} />}
				</motion.div>

				<motion.div variants={staggerItem}>
					<input
						type="tel"
						className={styles.inputText}
						style={{ marginBottom: 0 }}
						value={phone}
						onChange={(e) => setPhone(applyPhoneMask(e.target.value))}
						onBlur={() => setTouched(t => ({ ...t, phone: true }))}
						placeholder="Teléfono (10 dígitos)"
					/>
					{touched.phone && !phoneOk && (
						<motion.span
							className={styles.fieldError}
							initial={{ opacity: 0, y: -4 }}
							animate={{ opacity: 1, y: 0 }}
							transition={{ duration: 0.2 }}
						>
							Ingrese los 10 dígitos del teléfono
						</motion.span>
					)}
					{!(touched.phone && !phoneOk) && <div style={{ height: "1.25rem" }} />}
				</motion.div>

				<motion.div variants={staggerItem} style={{ marginTop: "0.5rem" }}>
					<motion.button
						className={styles.controlButton}
						onClick={handleForm}
						disabled={!isValid}
						whileHover={isValid ? btnHover : {}}
						whileTap={isValid ? btnTap : {}}
					>
						Siguiente
					</motion.button>
				</motion.div>
			</motion.div>
		</motion.div>
	);
};

export default QuestionContact;
